import { useContext, useMemo } from "react";
import { useTranslation } from "react-i18next";
import { Statuses } from "../../shared/Enums";
import MenuButton from "../../shared/MenuButton";
import { AccessControlContext } from "../../contexts/AccessControlContext";

interface Props {
  status?: Statuses;
  disabled?: boolean;
  loading?: boolean;
  customerId?: number;
  onWorkorderCompleteClick: () => void;
  onWorkorderCancelClick: () => void;
}

export default function WorkorderStatusChangeButton(props: Props) {
  const { t } = useTranslation();

  const accessControlContext = useContext(AccessControlContext);
  const userCanAddResults = accessControlContext.canI("add", "results", props.customerId);

  const { status, disabled, loading, onWorkorderCompleteClick, onWorkorderCancelClick } = props;

  const menuItems = useMemo(() => {
    let items = [];

    if (userCanAddResults && (status === Statuses.READY || status === Statuses.ASSIGNED))
      items.push({
        text: t("workorders.actions.complete"),
        onClick: onWorkorderCompleteClick,
      });

    if (status === Statuses.READY) {
      items.push({
        text: t("workorders.actions.cancel"),
        onClick: onWorkorderCancelClick,
      });
    }

    return items;
  }, [onWorkorderCancelClick, onWorkorderCompleteClick, status, t, userCanAddResults]);

  return (
    <MenuButton variant="button" buttonProps={{ disabled: loading || disabled }} menuItems={menuItems}>
      {t("workorders.changeStatus")}
    </MenuButton>
  );
}
